<template>
  <v-card class="base-card shadow">
    <v-card-title>
      <strong>Должности</strong>
    </v-card-title>

    <v-card-text class="pb-6">
      <div
        v-for="(position, index) in actualEmployeePositionList"
        :key="'position' + index"
      >
        <h3 class="my-4 pt-4">№ {{ index + 1 }}</h3>
        <SimpleTextRow
          name="Подразделение"
          :value="position.department?.name"
        />
        <SimpleTextRow
          name="Должность"
          :value="position.personTitle?.name"
        />
        <SimpleTextRow
          name="Вид должностного исполнения"
          :value="position.duty?.name"
        />
        <SimpleTextRow
          name="Ставка"
          :value="position.salaryRate?.name"
          :hide-border-bottom="index + 1 === actualEmployeePositionList.length"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { cloneDeep } from 'lodash'
import { Employee } from '../../models'
import SimpleTextRow from '../ui/SimpleTextRow'

export default {
  name: 'PositionsCard',

  props: {
    selectedEmployee: Object
  },

  components: {
    SimpleTextRow
  },

  data: () => {
    return {
      employee: new Employee()
    }
  },

  computed: {
    actualEmployeePositionList() {
      return this.employee?.positions?.filter(position => position.isActual) || []
    }
  },

  watch: {
    selectedEmployee: {
      deep: true,
      immediate: true,
      handler(val) {
        this.employee = cloneDeep(val)
      }
    }
  }
}
</script>

<style scoped></style>
